import PropTypes from 'prop-types';
import styles from './checkbox.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import { variants } from '../../atoms/icon';
import InteractiveElement from '../interactive-element';

const className = augmentClassName(styles);

const Checkbox = ({
  label,
  ariaLabel,
  id,
  disabled,
  checked,
  onChange,
  checkedColor,
  isCategoryCard,
  modelKey = null
}) => {
  const checkedStyles = {
    backgroundColor: checkedColor,
    border: 'none'
  };
  return (
    <InteractiveElement {...className('checkbox', disabled && 'disable')}
      style={checked ? checkedStyles : {}}
      role="checkbox"
      tabIndex="0"
      aria-label={ariaLabel}
      aria-checked={checked}
      id={id}
      value={label}
      onClick={!disabled && !isCategoryCard ? () => onChange(modelKey) : undefined}>
      {checked && <variants.CheckMark/>}
    </InteractiveElement>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  checkedColor: PropTypes.string,
  isCategoryCard: PropTypes.bool,
  modelKey: PropTypes.string
};

export default Checkbox;
